/**
 * Configuration for AI features in TinyMCE editor
 * This file contains functions to register AI-related icons and buttons
 */
import { customIcon } from 'components/TinymceEditor/icons/customIcon';

/**
 * Registers AI features in the TinyMCE editor if onAiButtonClick is provided
 * @param {object} editor - The TinyMCE editor instance
 * @param {function|undefined} onAiButtonClick - Optional callback when AI button is clicked
 * @returns {void}
 */
export const registerAiFeatures = (editor, onAiButtonClick) => {
  // Always register the custom icon so it's available
  editor.ui.registry.addIcon('ai-custom-icon', customIcon);

  // Only register the button if onAiButtonClick is provided
  if (onAiButtonClick) {
    editor.ui.registry.addButton('ai-custom-button', {
      text: 'AI',
      icon: 'ai-custom-icon',
      tooltip: 'Compose with AI',
      classes: 'ai-button',
      type: 'button',
      onAction() {
        // Call the provided callback function
        // This allows parent components to handle the AI interaction
        // (e.g., opening a modal, custom workflow, etc.)
        onAiButtonClick();
      },
    });
  }
};
